import React from "react";
import { Route, Navigate } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "../../components/AuthenticationGuard/AuthenticationGuard";
import PermissionGuard from "../../components/PermissionGuard/PermissionGuard";
import ErrorBoundaryWithFallback from "../../components/ErrorBoundary/ErrorBoundaryWithFallback";

// Lazy-loaded route components
const SalesCallTable = React.lazy(
  () =>
    import(
      "@/modules/salesCoaching/features/SalesCallScoring/components/SalesCallTable/SalesCallTable"
    ),
);
const SalesCallDetailPage = React.lazy(
  () =>
    import(
      "@/modules/salesCoaching/features/SalesCallScoring/components/SalesCallDetailPage/SalesCallDetailPage"
    ),
);
const SalesCoachingScoringSettingsPage = React.lazy(
  () =>
    import(
      "@/modules/salesCoaching/features/SalesCoachingScoringSettings/components/SalesCoachingScoringSettingsPage"
    ),
);
const IntegrationsPage = React.lazy(
  () =>
    import(
      "@/modules/salesCoaching/features/Integrations/components/IntegrationsPage"
    ),
);

/**
 * SalesCoachingRoutes
 *
 * Wraps the /sales-coaching section in the Auth0-based authentication guard
 * and manages access based on roles
 */
const SalesCoachingRoutes = (
  <Route
    element={
      <AuthenticationGuard
        component={() => <MainLayout section="sales-coaching" />}
      />
    }
    path="/sales-coaching"
  >
    <Route element={<Navigate replace to="/sales-coaching/calls" />} index />
    <Route
      element={
        <PermissionGuard
          requiredRoles={[
            "ROLE_SUPER_ADMIN",
            "ROLE_SALES_MANAGER",
            "ROLE_SALES_REP",
          ]}
        >
          <ErrorBoundaryWithFallback>
            <SalesCallTable />
          </ErrorBoundaryWithFallback>
        </PermissionGuard>
      }
      path="calls"
    />
    <Route
      element={
        <PermissionGuard
          requiredRoles={[
            "ROLE_SUPER_ADMIN",
            "ROLE_SALES_MANAGER",
            "ROLE_SALES_REP",
          ]}
        >
          <ErrorBoundaryWithFallback>
            <SalesCallDetailPage />
          </ErrorBoundaryWithFallback>
        </PermissionGuard>
      }
      path="calls/:callId"
    />
    <Route
      element={
        <PermissionGuard
          requiredRoles={["ROLE_SUPER_ADMIN", "ROLE_SALES_MANAGER"]}
        >
          <ErrorBoundaryWithFallback>
            <SalesCoachingScoringSettingsPage />
          </ErrorBoundaryWithFallback>
        </PermissionGuard>
      }
      path="scoring-settings"
    />
    <Route
      element={
        <PermissionGuard
          requiredRoles={["ROLE_SUPER_ADMIN", "ROLE_SALES_MANAGER"]}
        >
          <ErrorBoundaryWithFallback>
            <IntegrationsPage />
          </ErrorBoundaryWithFallback>
        </PermissionGuard>
      }
      path="integrations"
    />
  </Route>
);

export default SalesCoachingRoutes;
